import { Helmet } from 'react-helmet'
import { useTranslation } from 'react-i18next'
import EscritosLexnetView from 'src/components/views/EscritosLexnet/EscritosLexnetView'
import { useEscritoContext } from 'src/contexts/EscritoContext/EscritoContext'

export default function EscritosLexnet(): JSX.Element {
  const { t } = useTranslation()

  const { initialValues } = useEscritoContext()

  return (
    <>
      <Helmet>
        <title>{t('views.escritos_lexnet.title')}</title>
      </Helmet>
      {initialValues && <EscritosLexnetView />}
    </>
  )
}
